/** Blue "AI star" (light enough for the dark backdrop) — visually distinct from the yellow Telegram star (PRD §4.6). */
export function StarGlyph({ size = 14 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ verticalAlign: 'middle' }}>
      <path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z" fill="#6f9bff" />
    </svg>
  );
}
